module.exports = __webpack_public_path__ + "static/media/minus.1138e55c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/minus.svg
// module id = 422
// module chunks = 3